module.exports = __webpack_public_path__ + "media/scholarship_winners/lisa-sw-0ca8b41c.png";